<template>
  <v-card>
    <div class="mt-3">
      <v-container>
        <v-layout row wrap align-center>
          <v-flex xs12>
            <h1 class="text-pagename text-xs-center">Rider Request Cash</h1>
          </v-flex>

          <v-layout row wrap align-center>
            <v-spacer></v-spacer>

            <v-flex xs12 sm7>
              <v-layout row align-center justify-end>
                <!-- <v-switch
                color="primary"
                v-model="autoTransferEnabled"
                :label="
                  autoTransferEnabled
                    ? 'Auto withdraw enabled'
                    : 'Auto withdraw disabled'
                "
                small
                inset
                :disabled="autoLoading"
                @change="onToggleAutoTransfer"
                class="mr-3"
              /> -->

                <v-btn
                  flat
                  color="info"
                  @click="$router.push({ name: 'log_rider_request_cash' })"
                >
                  <span> see log</span>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </div>
    <requestCash :request_cash="request_cash" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import requestCash from "@/components/back-office/Rider/RequestCash/RequestCashTable";
import { utilsAxios } from "@/axios-path";
export default {
  components: {
    requestCash,
  },
  mounted() {
    // fetch auto-transfer state when page mounts
    this.fetchAutoTransferState();
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
        // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
      },
      {
        text: "Request cash",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {},
  computed: {
    ...mapState({
      request_cash: (state) => state.fetchCashRider.cash_request,
    }),
  },

  data() {
    return {
      autoTransferEnabled: false,
      autoLoading: false,
    };
  },

  methods: {
    // helper to parse likely response shapes
    _parseStateResponse(res) {
      // res is expected to be the axios response data (interceptor returns response.data)
      // Try common shapes: { msg: true, data: { state: 1 } } or { msg: true, state: 1 } or boolean
      if (res == null) return false;
      if (typeof res === "boolean") return res;
      if (typeof res === "object") {
        if (res.data !== undefined) {
          if (typeof res.data === "object") {
            return res.data.state !== undefined && res.data.state !== null
              ? res.data.state
              : res.data.auto_transfer_state !== undefined &&
                res.data.auto_transfer_state !== null
              ? res.data.auto_transfer_state
              : res.data.enabled !== undefined && res.data.enabled !== null
              ? res.data.enabled
              : false;
          }
          return res.data;
        }
        return res.state !== undefined && res.state !== null
          ? res.state
          : res.auto_transfer_state !== undefined &&
            res.auto_transfer_state !== null
          ? res.auto_transfer_state
          : res.enabled !== undefined && res.enabled !== null
          ? res.enabled
          : false;
      }
      return false;
    },

    async fetchAutoTransferState() {
      this.autoLoading = true;
      try {
        const state = await this.$store.dispatch(
          "fetchCashRider/getAutoTransferState"
        );
        this.autoTransferEnabled = Boolean(state);
      } catch (err) {
        this.$store.dispatch("disconnectNetwork", err);
      } finally {
        this.autoLoading = false;
      }
    },

    async toggleAutoTransfer(enabled) {
      this.autoLoading = true;
      try {
        const res = await this.$store.dispatch(
          "fetchCashRider/setAutoTransferState",
          enabled
        );
        // if action returns false -> failure
        if (res === false) {
          this.autoTransferEnabled = !enabled;
        }
      } catch (err) {
        this.autoTransferEnabled = !enabled;
        this.$store.dispatch("disconnectNetwork", err);
      } finally {
        this.autoLoading = false;
      }
    },

    onToggleAutoTransfer(val) {
      // val is the new v-model value
      this.toggleAutoTransfer(val);
    },
  },
};
</script>
